module.exports = __webpack_public_path__ + "img/P150T_weapon_10.964c9ae6.png";